import { VMSStringConstantsType } from "@/constants";
import { useConstants } from "./useConstants";

export const useStringConstants = (): VMSStringConstantsType => {
  const stringConstants = useConstants("STRING") as VMSStringConstantsType;
  return stringConstants;
};
